/**
 * FAB — Floating Action Button for creating habits.
 * Positioned fixed to the right of the content area, above the tab bar.
 */

import React, { useState } from 'react'
import { Plus } from 'lucide-react'
import { useHomeStore } from '@turnifly/shared/stores'
import { useAuthStore } from '@turnifly/shared/stores'
import { useHabitLimit } from '@turnifly/shared/hooks'
import { PremiumPage } from '../../profile/components/premium-page'

export const HabitFab: React.FC = () => {
  const { setFabOpen } = useHomeStore()
  const { user } = useAuthStore()
  const { data: limit } = useHabitLimit(user?.id)
  const [showPremium, setShowPremium] = useState(false)

  const handleOpen = (): void => {
    if (limit && !limit.can_create) {
      setShowPremium(true)
    } else {
      setFabOpen(true)
    }
  }

  return (
    <>
      {/* Fixed right edge, sits above tab bar (tab bar ~60px + safe + margin) */}
      <div className="fixed right-4 bottom-[calc(var(--tg-safe-area-inset-bottom,0px)+72px)] z-40">
        <button
          onClick={handleOpen}
          className="w-14 h-14 bg-primary text-white rounded-full flex items-center justify-center shadow-lg shadow-primary/30 hover:scale-105 transition-transform active:scale-95 tap-highlight-transparent"
          aria-label="Add new habit"
        >
          <Plus size={24} strokeWidth={2.5} />
        </button>
      </div>

      {showPremium && <PremiumPage isOpen={showPremium} onClose={() => setShowPremium(false)} />}
    </>
  )
}
